const SUPPORTED_NOTIFICATION_PATHS = [
  "/dashboard",
  "/dashboard/connections",
  "/dashboard/messages",
] as const;

type AppNavigationHandler = (target: string) => void;

let appNavigationHandler: AppNavigationHandler | null = null;

const isSupportedPathname = (pathname: string): boolean =>
  SUPPORTED_NOTIFICATION_PATHS.some((supportedPath) => {
    if (pathname === supportedPath) {
      return true;
    }

    return pathname.startsWith(`${supportedPath}/`);
  });

export const getSafeNotificationNavigationTarget = (
  actionUrl: string | undefined,
): string | null => {
  if (typeof actionUrl !== "string" || !actionUrl.startsWith("/")) {
    return null;
  }

  if (actionUrl.startsWith("//")) {
    return null;
  }

  try {
    const parsedUrl = new URL(actionUrl, window.location.origin);

    if (
      parsedUrl.origin !== window.location.origin ||
      !isSupportedPathname(parsedUrl.pathname)
    ) {
      return null;
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return null;
  }
};

export const setAppNavigationHandler = (
  handler: AppNavigationHandler,
): (() => void) => {
  appNavigationHandler = handler;

  return () => {
    if (appNavigationHandler === handler) {
      appNavigationHandler = null;
    }
  };
};

export const navigateToSafeAppPath = (target: string): boolean => {
  const safeTarget = getSafeNotificationNavigationTarget(target);

  if (!safeTarget || !appNavigationHandler) {
    return false;
  }

  appNavigationHandler(safeTarget);
  return true;
};
